module.exports = __webpack_public_path__ + "static/img/10008 (3).c51e972.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10008 (3).webp
// module id = 4Zo6
// module chunks = 14